module.exports = __webpack_public_path__ + "static/media/osmologo.24a97453.png";